import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import ReactSelect from 'react-select';
import { useGetUsers } from '../../hooks/queries/users/useGetUsers';
import { useRefreshEmployeeStatus } from '../../hooks/queries/moodle/useRefreshEmployeeStatus';

const RefreshEmployeeModal = ({ open, onClose }) => {
  const [searchInput, setSearchInput] = useState('');
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const { users, loading: usersLoading } = useGetUsers(searchInput);

  const { mutate, isPending } = useRefreshEmployeeStatus(() => {
    setSelectedEmployee(null);
    setSearchInput('');
    onClose();
  });

  const options = users.map((user) => ({
    label: `${user.firstName} ${user.lastName ?? ''} — ${user.emailId}`,
    value: user.emailId,
  }));

  const handleSubmit = () => {
    if (selectedEmployee) {
      mutate(selectedEmployee.value);
    }
  };

  const handleClose = () => {
    setSelectedEmployee(null);
    setSearchInput('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>Refresh Employee Compliance Status</DialogTitle>
      <DialogContent sx={{ pt: 2, overflow: 'visible' }}>
        <Typography variant="body2" color="text.secondary" mb={2}>
          Search for an employee to refresh their course compliance status.
        </Typography>
        <ReactSelect
          options={options}
          isLoading={usersLoading}
          placeholder="Search by name..."
          inputValue={searchInput}
          value={selectedEmployee}
          onInputChange={(val) => setSearchInput(val)}
          onChange={setSelectedEmployee}
          menuPortalTarget={document.body}
          filterOption={() => true}
          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose} disabled={isPending}>
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          loading={isPending}
          disabled={!selectedEmployee}
          onClick={handleSubmit}
        >
          Refresh
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default RefreshEmployeeModal;
